import styled from 'styled-components'

export const BankAccountDataWrap = styled.div``
